var map = {
	"./background/apples": 3,
	"./background/apples.jpg": 3,
	"./background/ccsanto-domingo": 4,
	"./background/ccsanto-domingo.png": 4,
	"./background/google-review": 5,
	"./background/google-review.png": 5,
	"./background/login-background": 6,
	"./background/login-background.jpg": 6,
	"./background/no_imagen_400": 7,
	"./background/no_imagen_400.jpg": 7,
	"./background/working": 8,
	"./background/working.svg": 8,
	"./fotos/fruteria": 9,
	"./fotos/fruteria.jpg": 9,
	"./fotos/m13-ico": 10,
	"./fotos/m13-ico.jpg": 10,
	"./icons/Apple": 11,
	"./icons/Apple.svg": 11,
	"./icons/Meat": 12,
	"./icons/Meat.svg": 12,
	"./icons/apple": 13,
	"./icons/apple.png": 13,
	"./icons/meat": 14,
	"./icons/meat.png": 14,
	"./icons/sausage": 15,
	"./icons/sausage.png": 15,
	"./icons/whatsapp": 16,
	"./icons/whatsapp.png": 16,
	"./logo/Logo": 0,
	"./logo/Logo copia grande": 17,
	"./logo/Logo copia grande.png": 17,
	"./logo/Logo-200px": 18,
	"./logo/Logo-200px 2": 19,
	"./logo/Logo-200px 2.png": 19,
	"./logo/Logo-200px.png": 18,
	"./logo/Logo.jpg": 35,
	"./logo/Logo.png": 0,
	"./logo/Logo.svg": 36,
	"./logo/Logo2": 20,
	"./logo/Logo2.png": 20,
	"./logo/Logo_full": 21,
	"./logo/Logo_full.jpg": 21,
	"./logo/Logo_g": 22,
	"./logo/Logo_g.jpg": 22,
	"./logo/nombre_logo": 2,
	"./logo/nombre_logo.png": 2,
	"./logo/nombre_logo.svg": 37,
	"./logo/nuevo_logo": 23,
	"./logo/nuevo_logo.jpg": 23,
	"./logo/nuevo_logo_frg": 24,
	"./logo/nuevo_logo_frg.jpeg": 24,
	"./logo/nuevo_logo_g": 25,
	"./logo/nuevo_logo_g.jpg": 25,
	"./logo/unica-logo": 26,
	"./logo/unica-logo.svg": 26
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;